import fetchProject from '../Services/fetchProject';

export default () => async (dispatch) => {
  dispatch(fetchProject());
}